import { useAtomValue, useSetAtom } from "jotai";
import type { TableWidgetCell } from "@/elements/table/tableCell";
import { MergeIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseMergeButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useMergeButton({ setActiveSubMenu }: UseMergeButtonProps): MenuOptionResult {
    const options = useAtomValue(
        widgetMenuOptionsByNameAtom("merge"),
    ) as widgetOption<TableWidgetCell>[];
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setNewMergeOptions = setNewOptions({ name: "merge", setWidgetMenuOptions });
        applyValue({ options, value: options, setNewOptions: setNewMergeOptions });
    };

    return {
        content: <MergeIcon />,
        handleClick,
    };
}
